import React from 'react';
import { number } from 'prop-types';

import { StarIcon, StarHalfIcon } from '@snapask/common-components';

import styles from './StarPicker.scss';

function StarPicker({ count, value }) {
  const arr = new Array(count).fill(0);
  const star = Math.ceil(value * 2) / 2;

  return (
    <div className={styles.starPicker}>
      {arr.map((e, i) => {
        const cn = star - i <= 0 ? '' : `${styles.light}`;

        return (
          <div key={`star-${i}`}>
            {star - 0.5 === 0 ? (
              <StarHalfIcon width={18} height={18} />
            ) : (
              <div className={cn}>
                <StarIcon width={18} height={18} />
              </div>
            )}
          </div>
        );
      })}
    </div>
  );
}

StarPicker.propTypes = {
  count: number,
  value: number,
};

StarPicker.defaultProps = {
  value: 0,
  count: 5,
};

export default StarPicker;



// WEBPACK FOOTER //
// ./app/components/StarPicker/StarPicker.jsx